import { ReactiveVar } from '@apollo/client'
import { IHeaderParams } from 'ag-grid-enterprise'
import { AgCustomHeader } from '../components/AgCustomHeader'
import { ColumnHeaderMenuState } from '../types'

/**
 * Creates AG Grid framework components with the specified reactive variable
 * for column header right-click menu handling.
 *
 * @param columnHeaderRightClickMenuVar - Reactive variable for managing header context menu state
 * @returns Object containing AG Grid framework components
 *
 * @example
 * ```tsx
 * import { createAgGridFrameworkComponents } from 'components/AgGrid';
 * import { myTableHeaderMenuVar } from 'cache/my-table';
 *
 * const frameworkComponents = useMemo(
 *   () => createAgGridFrameworkComponents(myTableHeaderMenuVar),
 *   []
 * );
 *
 * <AgGridReact
 *   components={frameworkComponents}
 *   // ... other props
 * />
 * ```
 */
export const createAgGridFrameworkComponents = (
  columnHeaderRightClickMenuVar: ReactiveVar<ColumnHeaderMenuState | false>
) => ({
  AgCustomHeader: (props: IHeaderParams) =>
    AgCustomHeader({
      ...props,
      columnHeaderRightClickMenuVar,
    }),
})
